<ng-container *ngIf="worker">
    <ng-container *transloco="let t">
      <div class="row mb-2">
        <div class="col-md-6">
          <div class="card">
            <div class="card-body" [innerHtml]="worker.device_info">
            </div>
          </div>

          <div class="alert alert-danger m-1" role="alert" *ngIf="worker.arc && worker.arc.active && !worker.arc.valid.valid">
            <i class="fa-solid fa-triangle-exclamation text-danger"></i> {{worker.name}} requires updates to Start a Shift and use the Safety Monitoring Center:
            <ul>
              @for (error of worker.arc.valid.errors; track error) {
              <li>{{error}}</li>
              }
            </ul>
          </div>
        </div>

        <div class="col-md-3 text-center" *ngIf="this.okService.hasMonitorWorkerAccess('workers','update')">
          <button type="button" class="btn btn-outline-dark fs-4" (click)="sendWelcome()">
            <i class="fa-solid fa-paper-plane fa-2x"></i> {{ t('Send Worker Welcome') }}
          </button>
          <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Will send their PIN and an app download link by email & SMS (if available)')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
        </div>
        <div class="col-md-3 text-center" *ngIf="!okService.isAdp() && this.okService.hasMonitorWorkerAccess('workers','update')">
          <ng-container *ngIf="worker.image">
            <img src="{{worker.image}}" class="img-thumbnail worker-profile" alt="Worker Image for {{worker.name}}"><br/>
            <button type="button" class="btn btn-secondary btn-sm text-white" (click)="removeImage()"><i class="fa-solid fa-trash"></i> {{ t('Remove') }}</button>
          </ng-container>
          <ng-container *ngIf="!worker.image">
            <button type="button" class="btn btn-light"  data-bs-toggle="modal" data-bs-target="#imageModal"><i class="fa-solid fa-image"></i> {{ t('Upload Profile Image') }}</button>
          </ng-container>
        </div>
      </div>


                  <form [formGroup]="formGroup" cForm (ngSubmit)="submitForm()" class="info-form">

                    <div class="row">
                      <div class="col-md-6">



                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilUser"></svg> {{ t('Name') }}</label>
                          <div class="col-8">
                            <input
                              [formControlName]="'name'"
                              cFormControl
                              placeholder="{{ t('Name') }}"
                              [ngClass]="{ 'border-danger': submitted && f['name'].errors }"
                            />
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('A suitable name for this worker account')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['name'].errors" class="invalid-feedback">
                                {{ t('A valid name is required') }}
                            </div>
                          </div>
                        </div>

                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilPhone"></svg> {{ t('Phone') }}</label>
                          <div class="col-8">
                            <input
                              [formControlName]="'phone'"
                              cFormControl
                              placeholder="{{ t('Phone') }}"
                              [ngClass]="{ 'border-danger': submitted && f['phone'].errors }"
                            />
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"   [attr.data-bs-content]="t('The phone number used to contact the worker. This is required for SMS text/Phonecall Check Ins and Automated Check In options')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['phone'].errors" class="invalid-feedback">
                                {{ t('A valid phone number is required') }}
                            </div>
                          </div>
                        </div>

                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end">
                            <svg cIcon name="cilPhone"></svg>
                            {{ worker.zoleo ? t('ZOLEO Number') : t('Alt Phone') }}
                          </label>
                          <div class="col-8">
                            <input *ngIf="!worker.zoleo"
                              [formControlName]="'cell'"
                              cFormControl
                              placeholder="{{ t('Alternate number for emergencies.') }}"
                              [ngClass]="{ 'border-danger': submitted && f['cell'].errors }"
                            />
                            <input *ngIf="worker.zoleo"
                              [formControlName]="'cell'"
                              cFormControl
                              placeholder="{{ t('ZOLEO Number') }}"
                              [ngClass]="{ 'border-danger': submitted && f['zoleo']?.errors }"
                            />
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" 
                              [attr.data-bs-content]="worker.zoleo ? 
                                t('You have a ZOLEO device. Enter the number here so your ZOLEO device will get reminders.') : 
                                t('An alternate number used to contact the worker in case of an emergency. Used in Escalation Procedures.')">
                              <i class="fa-solid fa-circle-info text-secondary"></i>
                            </button>
                            <div *ngIf="submitted && f['cell'].errors && !worker.zoleo" class="invalid-feedback">
                                {{ t('A valid phone number is required') }}
                            </div>
                            <div *ngIf="submitted && f['zoleo']?.errors && worker.zoleo" class="invalid-feedback">
                                {{ t('A valid ZOLEO number is required') }}
                            </div>
                          </div>
                        </div>

                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilEnvelopeClosed"></svg> {{ t('Email') }}</label>
                          <div class="col-8">
                            <input
                              [formControlName]="'email'"
                              cFormControl
                              placeholder="{{ t('Email') }}"
                              [ngClass]="{ 'border-danger': submitted && f['email'].errors }"
                            />
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" [attr.data-bs-content]="t('Email is optional for workers, but is used for start shift reminders and for linking to Google Assistant.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
                                {{ t('A valid email is required') }}
                            </div>
                          </div>
                        </div>


                        <ng-container *ngIf="okService.settings.international">

                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilLocationPin"></svg> {{ t('Country') }}</label>
                          <div class="col-8">
                            <ng-select [items]="countryListArray"
                            bindLabel="name"
                            bindValue="code"
                            formControlName="country"
                            placeholder="{{ t('Country') }}">
                          </ng-select>
                          <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" [attr.data-bs-content]="t('The country of the worker, required if they are in another country to the account country')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                          </div>
                        </div>

                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><i class="fa-solid fa-globe"></i> {{ t('Timezone') }}</label>
                          <div class="col-8">
                            <ng-select [items]="timezoneListArray"
                                      bindLabel="name"
                                      bindValue="tzCode"
                                      formControlName="timezone"
                                      placeholder="{{ t('Timezone') }}">
                            </ng-select>
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('The timezone of the worker, required if they are in another timezone to the account timezone')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                          </div>
                        </div>

                      </ng-container>


                      </div>
                      <div class="col-md-6">


                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cil-shield-alt"></svg> {{ t('Monitors') }}</label>
                          <div class="col-8">

                            <ng-select [items]="okService.monitors"  *ngIf="!okService.isExtendedPrivacy()"
                                      bindLabel="name"
                                      bindValue="id"
                                      [multiple]="true"
                                      formControlName="monitors"
                                      [ngClass]="{ 'border-danger': submitted && f['monitors'].errors }" >
                            </ng-select>
                            <input class="form-control" type="text" [value]="worker.monitor_names" readonly  *ngIf="okService.isExtendedPrivacy()">
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Choose monitors from the list, they will get alerts for missed check ins and help alerts')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['monitors'].errors" class="invalid-feedback">
                              {{ t('You have reached the limit of monitors that can be assigned to a worker. If you require more monitors then please use our Alert Loops feature.') }}
                            </div>
                          </div>
                        </div>



                        <div class="form-group row mb-2" *ngIf="okService.alert_loops.length > 0">
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilReload"></svg> {{ t('Alert Loop') }}</label>
                          <div class="col-8">
                            <ng-select [items]="okService.alert_loops" *ngIf="!okService.isExtendedPrivacy()"
                            bindLabel="name"
                            bindValue="id"
                            [multiple]="false"
                            formControlName="alert_loop"
                            placeholder="{{ t('None') }}">
                          </ng-select>
                          <input class="form-control" type="text" [value]="worker.alert_loop_name" readonly  *ngIf="okService.isExtendedPrivacy()">
                          <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" [attr.data-bs-content]="t('You may choose an alert loop for this worker. If the worker is in a group with an alert loop, alerts will trigger that alert loop.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                          </div>
                        </div>

                        <div class="form-group row mb-2"  *ngIf="okService.groups.length > 0">
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilGrain"></svg> {{ t('Groups') }}</label>
                          <div class="col-8">

                            <ng-select [items]="okService.groups" *ngIf="!okService.isExtendedPrivacy()"
                                      bindLabel="name"
                                      bindValue="id"
                                      [multiple]="true"
                                      formControlName="groups">
                            </ng-select>
                            <input class="form-control" type="text" [value]="worker.group_names" readonly  *ngIf="okService.isExtendedPrivacy()">
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Choose groups from the list, workers may only be synced with one group at a time')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                          </div>
                        </div>

                        <!-- Should alerts and messages be sent to the worker using Whatsapp? -->
                        <div class="form-group row mb-2"  *ngIf="okService.isGeotab()">
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cil-car-alt"></svg> {{ t('Vehicles') }}

                            <span  *ngIf="!okService.isExtendedPrivacy() && worker.geotab_id"><br/>
                              <button type="button" class="btn btn-link" (click)="updateVehicle()" *ngIf="!loading_vehicle">Update from Geotab</button>
                              <span *ngIf="loading_vehicle"><i class="fa-solid fa-spinner fa-spin"></i></span>
                            </span>


                          </label>
                          <div class="col-8">

                            <ng-select [items]="okService.vehicles" *ngIf="!okService.isExtendedPrivacy()"
                                      bindLabel="name"
                                      bindValue="id"
                                      formControlName="vehicle_id">
                            </ng-select>
                            <input class="form-control" type="text" [value]="worker.vehicle ? worker.vehicle.name : ''" readonly  *ngIf="okService.isExtendedPrivacy()">

                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Assign at vehicle to the worker')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <p class="fw-light" *ngIf="!okService.isExtendedPrivacy()">{{ t('Only enabled vehicles appear in this list, enable them on the vehicles page.') }}</p>
                          </div>
                        </div>


                        <div class="form-group row mb-2" >
                          <label class="col-4 col-form-label text-start text-sm-end"><svg cIcon name="cilUser"></svg> {{ t('Information') }}</label>
                          <div class="col-8">
                          <textarea class="form-control"
                          id="exampleFormControlTextarea1"
                          formControlName="information"
                          cFormControl
                          rows="3"></textarea>
                          <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover"  [attr.data-bs-content]="t('Please add any useful information about the worker, such as vehicle details, emergency information etc')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                        </div>
                        </div>

                      </div>

                    </div>

                    <c-row>

                    </c-row>

                    <c-row>
                      <c-col xs="6" class="mt-3" *ngIf="this.okService.hasMonitorWorkerAccess('workers','update')">
                        @if(worker.arc && worker.arc.active && worker.status && worker.status.working) {
                          <p class="alert alert-danger"><i class="fa-solid fa-triangle-exclamation text-danger"></i> {{ t('This worker is currently on shift in OK Alone and using the Safety Monitoring Center and cannot have their info changed until they are finished working.') }}</p>
                          <button cButton class="px-4 text-white btn-info" type="submit" disabled="disabled">
                            <i class="fa-solid fa-check"></i> {{ t('Update the Worker') }}
                          </button>
                        }@else {
                          <button cButton class="px-4 text-white btn-info" type="submit">
                            <i class="fa-solid fa-check"></i> {{ t('Update the Worker') }}
                          </button>
                        }


                      </c-col>
                    </c-row>

                  </form>



                  <!-- Modal -->
                  <div class="modal fade" id="imageModal" tabindex="-1" aria-labelledby="imageModalLabel" aria-hidden="true">
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="imageModalLabel">{{ t('Upload a Worker Image') }}</h5>
                          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                          <worker-image-upload [worker]="worker" (imageUploaded)="imageUploaded()"></worker-image-upload>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
</ng-container>



